import React from 'react'
import { observer } from 'mobx-react-lite'

import { CurrencyInput, ListItemAction, useGlobalCopyStore, useGoalStore } from '../../../common'
import { Goal } from '../../../core'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface OriginalBalanceActionProps {
  goal: Goal
}

export const OriginalBalanceAction = observer(({ goal }: OriginalBalanceActionProps) => {
  const { goals: copy } = useGlobalCopyStore()
  const { setAlert, setSelectedGoal, updateGoal } = useGoalStore()

  const [balance, setBalance] = React.useState<number>(goal.initial_amount)

  const isNew = !goal.guid
  const isInvlaid = balance < 0 || balance > 99999999.99

  const handleSave = async () => {
    const updatedGoal = { ...goal, initial_amount: balance }
    goal.initial_amount = balance
    if (isNew) {
      setSelectedGoal(updatedGoal)
    } else {
      await updateGoal({ ...goal, initial_amount: balance })
      setAlert(copy.alert_goal_updated_balance)
    }
  }

  const handleCancel = () => {
    setTimeout(() => {
      setBalance(goal.initial_amount)
    }, 250)
  }

  return (
    <ListItemAction
      isDisabled={goal.is_complete}
      isSaveDisabled={isInvlaid}
      label={copy.details_original_balance}
      onCancel={handleCancel}
      onSave={handleSave}
      primaryText={copy.details_original_balance}
      secondaryText={formatCurrency(goal.initial_amount, '0,0')}
      zeroStateText={
        !goal.initial_amount && !goal.is_complete ? copy.add_original_balance : undefined
      }
    >
      <CurrencyInput
        amount={balance}
        autoFocus={true}
        error={isInvlaid}
        fullWidth={true}
        minAmount={0}
        setAmount={(v) => setBalance(!isNaN(Number(v)) ? Number(v) : balance)}
        sx={{ '.MuiTypography-body1': { p: 0 } }}
      />
    </ListItemAction>
  )
})
